module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="effect-library">\n    <div class="row">\n        <div class="effect selected" data-target="scale">\n            <div class="effect-demo"></div>\n        </div>\n        <div class="effect" data-target="opacity">\n            <div class="effect-demo"></div>\n        </div>\n        <div class="effect" data-target="rotate">\n            <div class="effect-demo"></div>\n        </div>\n        <div class="effect" data-target="pulse">\n            <div class="effect-demo"></div>\n        </div>\n        <div class="effect" data-target="imageToggle">\n            <div class="effect-demo"></div>\n        </div>\n    </div>\n</div>\n\n<div class="effect-configuration-region"></div>\n\n<div class="timing-effect-configuration zmags-input-control small columns';
 if (triggerType == "attention") {;
__p += ' show';
};
__p += '">\n    <div class="pull-left">\n        <label data-unit="sec">Duration: <input type="number" step="0.1" class="duration"></label>\n    </div>\n    <div class="pull-right">\n        <label data-unit="sec">Pause: <input type="number" step="0.1" class="post-delay"></label>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/EffectLibraryView.tpl
// module id = 1751
// module chunks = 0